/* ------------------------------------------------------------------
   Strapion — enriquecido de datos estructurados
   ------------------------------------------------------------------
   El tema Horizon emite un ProductGroup correcto pero incompleto: le
   faltan imagen a nivel de grupo, variesBy, y los datos de envío y
   devoluciones que Google usa para mostrar "Envío gratis · 30 días"
   directamente en el resultado de búsqueda.

   Aquí NO se añade un segundo bloque ProductGroup: se modifica el que
   ya existe. Dos bloques del mismo tipo en una página se contradicen y
   Google puede acabar ignorando ambos.

   Los valores de envío y devolución replican literalmente lo publicado
   en /pages/envios y /pages/devoluciones. Declarar condiciones que no
   se cumplen es motivo de acción manual por parte de Google.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  // --- Políticas reales de la tienda -------------------------------
  var ENVIO = {
    '@type': 'OfferShippingDetails',
    shippingRate: {
      '@type': 'MonetaryAmount',
      value: '0',
      currency: 'USD',
    },
    shippingDestination: {
      '@type': 'DefinedRegion',
      addressCountry: 'US',
    },
    deliveryTime: {
      '@type': 'ShippingDeliveryTime',
      handlingTime: {
        '@type': 'QuantitativeValue',
        minValue: 1,
        maxValue: 3,
        unitCode: 'DAY',
      },
      transitTime: {
        // 15-30 días laborables, tal y como se anuncia en /pages/envios
        '@type': 'QuantitativeValue',
        minValue: 15,
        maxValue: 30,
        unitCode: 'DAY',
      },
    },
  };

  var DEVOLUCION = {
    '@type': 'MerchantReturnPolicy',
    applicableCountry: 'US',
    returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
    merchantReturnDays: 30,
    returnMethod: 'https://schema.org/ReturnByMail',
    // El porte de devolución lo asume el comprador salvo producto
    // defectuoso: eso es ReturnShippingFees, no FreeReturn.
    returnFees: 'https://schema.org/ReturnShippingFees',
  };

  function bloquesJsonLd() {
    return Array.prototype.slice.call(
      document.querySelectorAll('script[type="application/ld+json"]')
    );
  }

  function enriquecerProductGroup() {
    var scripts = bloquesJsonLd();

    for (var i = 0; i < scripts.length; i++) {
      var el = scripts[i];
      if (el.dataset.strapionEnriched) continue;

      var datos;
      try {
        datos = JSON.parse(el.textContent);
      } catch (e) {
        continue;
      }
      if (!datos || datos['@type'] !== 'ProductGroup') continue;

      var variantes = datos.hasVariant || [];

      // 1. Imagen a nivel de grupo: requisito de Google Shopping.
      //    Se reúnen las de las variantes, sin repetir.
      if (!datos.image) {
        var imgs = [];
        variantes.forEach(function (v) {
          var im = v.image;
          if (!im) return;
          (Array.isArray(im) ? im : [im]).forEach(function (u) {
            var url = typeof u === 'string' ? u : u && u.url;
            if (url && imgs.indexOf(url) === -1) imgs.push(url);
          });
        });
        var og = document.querySelector('meta[property="og:image"]');
        if (!imgs.length && og && og.content) imgs.push(og.content);
        if (imgs.length) datos.image = imgs;
      }

      // 2. variesBy: aclara que las variantes se distinguen por modelo
      //    de dispositivo, no que sean productos distintos.
      if (!datos.variesBy) datos.variesBy = ['https://schema.org/model'];

      // 3. Envío y devoluciones en cada oferta.
      variantes.forEach(function (v) {
        var of = v.offers;
        if (!of) return;
        (Array.isArray(of) ? of : [of]).forEach(function (o) {
          if (!o.shippingDetails) o.shippingDetails = ENVIO;
          if (!o.hasMerchantReturnPolicy) o.hasMerchantReturnPolicy = DEVOLUCION;
        });
      });

      el.textContent = JSON.stringify(datos);
      el.dataset.strapionEnriched = '1';
    }
  }

  function anadirMigas() {
    if (document.getElementById('strapion-breadcrumbs')) return;
    if (!/\/products\//.test(location.pathname)) return;

    var h1 = document.querySelector('h1');
    var nombre = h1 ? h1.textContent.trim() : document.title;
    if (!nombre) return;

    var migas = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: location.origin + '/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Bands',
          item: location.origin + '/collections/all',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: nombre,
          item: location.origin + location.pathname,
        },
      ],
    };

    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.id = 'strapion-breadcrumbs';
    s.textContent = JSON.stringify(migas);
    document.head.appendChild(s);
  }

  function ejecutar() {
    enriquecerProductGroup();
    anadirMigas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ejecutar);
  } else {
    ejecutar();
  }

  // El tema reescribe el JSON-LD al cambiar de variante.
  new MutationObserver(function () {
    enriquecerProductGroup();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
